module.exports = __webpack_public_path__ + "static/media/logo.79848e19.png";